import styles from './feature_card.module.scss';
import {Link} from 'react-router-dom';

interface OwnProps {
    icon: string;
    title: string;
    to: string;
}
export function FeatureCard({icon, title, to}: OwnProps) {
    return (
        <Link to={to} className={styles.feature_card} viewTransition={true}>
            <i className={icon}></i>
            <span className={styles.feature_card__title}>{title}</span>
        </Link>
    );
}
